var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("ModalFullScreen", {
    attrs: { size: "md", modalId: "modal-lv3" },
    on: { close: _vm.closeModal },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _c("span", { staticClass: "font-semibold text-base mb-5" }, [
              _vm._v(
                _vm._s(_vm.updatedLocation ? "Edit" : "Add") + " Location"
              ),
            ]),
            _c(
              "span",
              {
                staticClass:
                  "cursor-pointer flex items-center justify-center absolute top-4 right-5",
                on: {
                  click: _vm.closeModal,
                  mouseover: function ($event) {
                    _vm.isHovered = true
                  },
                  mouseout: function ($event) {
                    _vm.isHovered = false
                  },
                },
              },
              [
                !_vm.isHovered
                  ? _c("CrossIcon", { staticClass: "h-3.5 w-3.5" })
                  : _vm._e(),
                _vm.isHovered
                  ? _c("CrossIconHover", { staticClass: "close-icon" })
                  : _vm._e(),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "content",
        fn: function () {
          return [
            _c("ModalContent", { staticClass: "relative" }, [
              _c(
                "div",
                { staticClass: "mt-5" },
                [
                  _c("ValidationObserver", [
                    _c(
                      "form",
                      { staticClass: "mt-5" },
                      [
                        _c("ValidationProvider", {
                          attrs: { name: "Country", rules: "required" },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function ({ errors }) {
                                return [
                                  _c(
                                    "FormGroup",
                                    {
                                      attrs: {
                                        title: "",
                                        errors: errors,
                                        isIcon: false,
                                        inputClass: "fullwidthInput",
                                      },
                                      on: {
                                        hasErrors: (hasErrors) => {
                                          _vm.countryHasErrors = hasErrors
                                        },
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "title",
                                            fn: function () {
                                              return [
                                                _c(
                                                  "p",
                                                  { staticClass: "mb-2" },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "required-icon",
                                                      },
                                                      [_vm._v("*")]
                                                    ),
                                                    _vm._v("Country "),
                                                  ]
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    },
                                    [
                                      _c("ProfileCountrySelect", {
                                        attrs: {
                                          getcontainerStyle: "fullWidthInput",
                                        },
                                        model: {
                                          value: _vm.country,
                                          callback: function ($$v) {
                                            _vm.country = $$v
                                          },
                                          expression: "country",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("ValidationProvider", {
                          attrs: { name: "State" },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function ({ errors }) {
                                return [
                                  _c("RegionInput", {
                                    staticClass: "mt-2",
                                    attrs: {
                                      countries: _vm.country,
                                      errors: errors,
                                      iconStyle: "customIcon",
                                      title: "Region",
                                      isIcon: false,
                                      shouldFullWidth: "customFullWidthInput",
                                      getcontainerStyle: "customFullWidthInput",
                                    },
                                    model: {
                                      value: _vm.state,
                                      callback: function ($$v) {
                                        _vm.state = $$v
                                      },
                                      expression: "state",
                                    },
                                  }),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("FormGroup", {
                          staticClass: "flex-1 mt-2",
                          attrs: {
                            name: "postal_code",
                            isIcon: false,
                            type: "search",
                            title: "Postal / Zip Code",
                            placeholder: "Enter postal / zip code",
                            iconStyle: "customIcon",
                            inputClass: "fullwidthInput",
                          },
                          model: {
                            value: _vm.postalCode,
                            callback: function ($$v) {
                              _vm.postalCode = $$v
                            },
                            expression: "postalCode",
                          },
                        }),
                        _c("ValidationProvider", {
                          attrs: {
                            name: "City",
                            rules: "name_with_specific_symbols",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function ({ errors }) {
                                return [
                                  _c("FormGroup", {
                                    staticClass: "mt-2",
                                    attrs: {
                                      title: "City",
                                      type: "search",
                                      placeholder: "Enter city",
                                      iconStyle: "customIcon",
                                      inputClass: "fullwidthInput",
                                      errors: errors,
                                      isIcon: false,
                                    },
                                    on: {
                                      hasErrors: (hasErrors) => {
                                        _vm.cityHasErrors = hasErrors
                                      },
                                    },
                                    model: {
                                      value: _vm.city,
                                      callback: function ($$v) {
                                        _vm.city =
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                      },
                                      expression: "city",
                                    },
                                  }),
                                ]
                              },
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                  ]),
                  _c(
                    "div",
                    { staticClass: "flex justify-end mt-2 pt-3 gap-4" },
                    [
                      _c("UIButton", {
                        attrs: {
                          buttonText: "Cancel",
                          size: "lg",
                          variant: "outline",
                          processing: _vm.processing,
                        },
                        on: { click: _vm.closeModal },
                      }),
                      _vm.allNullValue
                        ? _c("UIButton", {
                            attrs: {
                              buttonText: "Add",
                              size: "lg",
                              variant: "black",
                              processing: _vm.processing,
                              disabled: !!_vm.errors?.length,
                            },
                            on: { click: _vm.addLocation },
                          })
                        : _vm._e(),
                      !_vm.allNullValue
                        ? _c("UIButton", {
                            attrs: {
                              buttonText: "Save",
                              size: "lg",
                              variant: "black",
                              processing: _vm.processing,
                              disabled: !_vm.location || !!_vm.errors?.length,
                            },
                            on: { click: _vm.editLocation },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }